import request from '../utils/request'
import { requestPath } from '@/utils/global.js'

export function linksAPI(params) { //友情链接
    return request({
        url: `${requestPath.common}/home-page/links/list`,
        method: 'get',
        params
    })
}

export function footerAPI(params) { //页脚
    return request({
        url: `${requestPath.common}/footer/page`,
        method: 'get',
        params
    })
}

export function footerDetailsAPI(params) { //页脚详情
    return request({
        url: `${requestPath.common}/footer/${params}`,
        method: 'get',
    })
}

export function dictionaryAPI(params) { //获取底部版权
    return request({
        url: `${requestPath.common}/basicParameterSetting/get/copyrightInformation`,
        method: 'get',
        params
    })
}

export function getCopyRightAPI() { // 版权信息
    return request({
        url: `${requestPath.common}/basicParameterSetting/get/copyrightInformation`,
        method: 'get',
    })
}

export function shopCartAPI(data) { //添加购物车
    return request({
        url: `${requestPath.resource}/shopping-cart/save`,
        method: 'post',
        data
    })
}

export function getCommentListAPI(params) { //获取评论列表
    return request({
        url: `${requestPath.resource}/comment/page`,
        method: 'get',
        params
    })
}

export function commentSaveAPI(data) { //评论或回复
    return request({
        url: `${requestPath.resource}/comment/save`,
        method: 'post',
        data
    })
}

export function hasCourseAPI() { //判断时候有课程
    return request({
        url: `${requestPath.resource}/course-library/isExist`,
        method: 'get',
    })
}

export function getReviewAPI(params) { //评论
    return request({
        url: `${requestPath.resource}/comment/page`,
        method: 'get',
        params
    })
}

export function addReviewAPI(data) { //添加评论
    return request({
        url: `${requestPath.resource}/comment/save`,
        method: 'post',
        data
    })
}


export function reviewAgreeAPI(data) { //点赞
    return request({
        url: `${requestPath.resource}/comment/agree`,
        method: 'post',
        data
    })
}

export function collectAPI(data) { //收藏
    return request({
        url: `${requestPath.resource}/member-collection/batch/save`,
        method: 'post',
        data
    })
}

export function collectDelAPI(data) { //取消收藏
    return request({
        url: `${requestPath.resource}/member-collection/batch/delete`,
        method: 'post',
        data
    })
}

export function saveAgreeAPI(data) { //提交意见反馈
    return request({
        url: `${requestPath.common}/message/save`,
        method: 'post',
        data
    })
}

export function getVideoAddressAPI(params) { //获取视频切片地址
    return request({
        url: `${requestPath.file}get/video/m3u8`,
        method: 'get',
        params
    })
}

export function getVideoImgAPI(params) { //获取视频默认封面地址
    return request({
        url: `${requestPath.file}file/getVideoImg`,
        method: 'get',
        params
    })
}

export function searchTipAPI(params) { //获取视频默认封面地址
    return request({
        url: `${requestPath.resource}/resource/search/list`,
        method: 'get',
        params
    })
}

export function getRecommBookAPI(params) { //获取推荐图书
    return request({
        url: `${requestPath.resource}/ebook/other/list`,
        method: 'get',
        params
    })
}

export function recommendAPI(params) { //推荐位
    return request({
        url: `${requestPath.resource}/recommend/content/list`,
        method: 'get',
        params
    })
}

export function collectSingleAPI(data) { //资源的单条收藏和取消收藏
    return request({
        url: `${requestPath.resource}/member-collection/save`,
        method: 'post',
        data
    })
}

export function getFileAPI(params) { //audio-file
    return request({
        url: `${requestPath.file}/getFilePath`,
        method: 'get',
        params
    })
}

export function messageAPI(params) { //查询是否有未读消息
    return request({
        url: `${requestPath.member}/pm/count`,
        method: 'get',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/common.js